/* CHOZEN Navigation Pilot: desktop mega menu behaviour.
   One global, idempotent initialisation with delegated listeners, so theme-editor section reloads never add duplicate handlers.
   Semantics: disclosure buttons (aria-expanded + aria-controls). No ARIA menu roles are used. */
(function () {
  if (window.__chozenMega) return;
  window.__chozenMega = true;

  var DESK = window.matchMedia('(min-width:1000px)');
  var HOVER = window.matchMedia('(hover:hover) and (pointer:fine)');
  var tOpen = null, tClose = null;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function panelOf(t) { return document.getElementById(t.getAttribute('aria-controls')); }
  function trigOf(p) { return document.querySelector('[data-chozen-trigger][aria-controls="' + p.id + '"]'); }
  function openPanel() { return document.querySelector('[data-chozen-mega]:not([hidden])'); }
  function focusables(p) {
    return $$('a[href], button:not([disabled])', p).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1' && !el.closest('[hidden]') && el.getClientRects().length > 0;
    });
  }
  /* The overlay must be a direct child of <body>: inside the header it is clipped to the header box.
     Keep exactly one, even after theme-editor section reloads re-render the header markup. */
  function scrim() {
    var s = null;
    $$('[data-chozen-scrim]').forEach(function (e) {
      if (!s && e.parentNode === document.body) { s = e; return; }
    });
    $$('[data-chozen-scrim]').forEach(function (e) {
      if (e === s) return;
      if (!s) { document.body.appendChild(e); s = e; } else { e.remove(); }
    });
    return s;
  }

  function open(trig, focusFirst) {
    var p = panelOf(trig); if (!p) return;
    clearTimeout(tClose);
    $$('[data-chozen-mega]').forEach(function (o) {
      if (o !== p && !o.hidden) { o.hidden = true; var t = trigOf(o); if (t) t.setAttribute('aria-expanded', 'false'); }
    });
    p.hidden = false;
    trig.setAttribute('aria-expanded', 'true');
    var s = scrim(); if (s) s.hidden = false;
    initBrands(p);
    if (focusFirst) { var f = focusables(p)[0]; if (f) f.focus(); }
  }
  function close(restore) {
    clearTimeout(tOpen); clearTimeout(tClose);
    var p = openPanel(); if (!p) return;
    var t = trigOf(p);
    p.hidden = true;
    if (t) { t.setAttribute('aria-expanded', 'false'); if (restore) t.focus(); }
    var s = scrim(); if (s) s.hidden = true;
  }

  /* ---- audience tabs ---- */
  function activateTab(btn) {
    var p = btn.closest('[data-chozen-mega]'); if (!p) return;
    var id = btn.getAttribute('data-chozen-tab');
    $$('[data-chozen-tab]', p).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    $$('[data-chozen-tabpanel]', p).forEach(function (l) { l.hidden = l.getAttribute('data-chozen-tabpanel') !== id; });
  }

  /* ---- brand discovery panel (filter by the store's own brand types) ---- */
  function initBrands(p) {
    var root = p.querySelector('[data-chozen-brands]');
    if (!root || root.__ready) return;
    root.__ready = true;
    var grid = root.querySelector('[data-chozen-grid]');
    var tiles = $$('.chozen-brand', grid).sort(function (a, b) {
      return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'en', { sensitivity: 'base' });
    });
    tiles.forEach(function (t) { grid.appendChild(t); });
    root.__state = { type: '', expanded: false };
    renderBrands(root);
  }
  function renderBrands(root) {
    var st = root.__state, limit = parseInt(root.getAttribute('data-limit'), 10) || 16;
    var tiles = $$('.chozen-brand', root);
    var match = tiles.filter(function (t) { return !st.type || t.getAttribute('data-types').indexOf('|' + st.type + '|') > -1; });
    tiles.forEach(function (t) { t.hidden = true; });
    var shown = st.expanded ? match : match.slice(0, limit);
    shown.forEach(function (t) { t.hidden = false; });
    var c = root.querySelector('[data-chozen-count]');
    if (c) c.textContent = 'מוצגים ' + shown.length + ' מתוך ' + match.length + ' מותגים, לפי ABC';
    var b = root.querySelector('[data-chozen-toggle]');
    if (b) {
      b.hidden = match.length <= limit;
      b.textContent = st.expanded ? 'הצג פחות' : 'הצג את כל ' + match.length;
      b.setAttribute('aria-expanded', String(st.expanded));
    }
  }

  /* ---- logo fallback: brand name as text if an image fails ---- */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.chozen-brand')) {
      var s = document.createElement('span'); s.textContent = t.getAttribute('data-name') || ''; t.replaceWith(s);
    }
  }, true);

  /* ---- clicks ---- */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-chozen-trigger]');
    if (trig) {
      var p = panelOf(trig);
      if (!DESK.matches) return;
      if (e.detail > 0 && HOVER.matches) {
        /* mouse click keeps the original "follow the item link" behaviour */
        var href = trig.getAttribute('data-href'); if (href) window.location.assign(href);
        return;
      }
      if (p && !p.hidden) close(false); else open(trig, e.detail === 0);
      return;
    }
    var tab = e.target.closest('[data-chozen-tab]'); if (tab) { activateTab(tab); return; }
    var chip = e.target.closest('[data-chozen-chip]');
    if (chip) {
      var root = chip.closest('[data-chozen-brands]');
      $$('[data-chozen-chip]', root).forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
      root.__state.type = chip.getAttribute('data-chozen-chip'); root.__state.expanded = false; renderBrands(root);
      return;
    }
    var tg = e.target.closest('[data-chozen-toggle]');
    if (tg) { var r2 = tg.closest('[data-chozen-brands]'); r2.__state.expanded = !r2.__state.expanded; renderBrands(r2); tg.focus(); return; }
    if (openPanel() && !e.target.closest('[data-chozen-mega]')) close(false);
  });

  /* ---- hover (pointer devices only) ---- */
  document.addEventListener('mouseover', function (e) {
    if (!DESK.matches || !HOVER.matches) return;
    var trig = e.target.closest('[data-chozen-trigger]');
    var pan = e.target.closest('[data-chozen-mega]');
    var tab = e.target.closest('[data-chozen-tab]');
    if (tab) activateTab(tab);
    if (trig) {
      clearTimeout(tClose); clearTimeout(tOpen);
      var p = panelOf(trig);
      if (p && p.hidden) tOpen = setTimeout(function () { open(trig, false); }, openPanel() ? 0 : 130);
    } else if (pan) {
      clearTimeout(tClose); clearTimeout(tOpen);
    } else {
      clearTimeout(tOpen);
      if (openPanel()) { clearTimeout(tClose); tClose = setTimeout(function () { close(false); }, 260); }
    }
  });

  /* ---- keyboard ---- */
  /* Escape runs in the capture phase so it wins over other widgets that listen for Escape */
  window.addEventListener('keydown', function (e) {
    var p = openPanel();
    if (e.key !== 'Escape' || !p) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var rt = trigOf(p); close(true);
    if (rt) setTimeout(function () { if (document.activeElement !== rt) rt.focus(); }, 0);
  }, true);

  document.addEventListener('keydown', function (e) {
    var p = openPanel();
    if (e.key === 'Escape' && p) {
      e.preventDefault(); e.stopImmediatePropagation();
      var rt = trigOf(p); close(true);
      /* a third-party widget may also react to Escape: re-assert focus after it ran */
      if (rt) setTimeout(function () { if (document.activeElement !== rt) rt.focus(); }, 0);
      return;
    }
    var trig = e.target.closest && e.target.closest('[data-chozen-trigger]');
    if (trig) {
      var tp = panelOf(trig);
      if (e.key === 'ArrowDown') { e.preventDefault(); open(trig, true); return; }
      if (e.key === 'Tab' && !e.shiftKey && tp && !tp.hidden) {
        var f = focusables(tp)[0]; if (f) { e.preventDefault(); f.focus(); }
      }
      return;
    }
    if (p && e.target.closest && e.target.closest('[data-chozen-mega]') && e.key === 'Tab') {
      var list = focusables(p), idx = list.indexOf(e.target);
      if (e.shiftKey && idx === 0) { e.preventDefault(); var t0 = trigOf(p); if (t0) t0.focus(); }
      else if (!e.shiftKey && idx === list.length - 1) { var t1 = trigOf(p); close(false); if (t1) t1.focus(); }
    }
  });
  document.addEventListener('focusin', function (e) {
    if (openPanel() && !(e.target.closest && e.target.closest('[data-chozen-mega],[data-chozen-trigger]'))) close(false);
  });

  /* small public API so other header widgets (search) can close an open panel without stealing focus */
  window.chozenMega = { close: function (restore) { close(!!restore); } };

  var onChange = function () { close(false); };
  if (DESK.addEventListener) DESK.addEventListener('change', onChange); else DESK.addListener(onChange);
  document.addEventListener('shopify:section:load', onChange);
  document.addEventListener('shopify:section:unload', onChange);
})();
